define("SuiteDB.SDBProductMapPairs.SS2Model", ["Backbone", "Utils"], function (
  Backbone,
  Utils
) {
  "use strict";

  return Backbone.Model.extend({
    urlRoot: Utils.getAbsoluteUrl(
      getExtensionAssetsPath(
        "Modules/SDBProductMapPairs/SuiteScript2/SDBProductMapPairs.Service.ss"
      ),
      true
    ),
  });
});
